import request from "root/js/request";

export const getAvailableSupplyDates = async ({ cabinet_id, sales_share_history_period }) => {
  const response = await request({
    url: `analytics/wh_supply/split_to_supplies/supply_dates/`,
    method: "get",
    params: {
      cabinet_id,
      sales_share_history_period,
    },
  });
  return response.data;
};
